export const environment = {
  production: false,
  // Real Loss Run Intelligence API domain. If running locally via `ng serve` and this
  // origin isn't CORS-allowlisted yet, use proxy.conf.json (apiUrl: '/lossrun-api') instead.
  apiUrl: 'https://lossrun-agent.dev.falconsystem.com',
  // Dev-only credentials for the Loss Run Intelligence API. Do not use this pattern in production —
  // a real deployment should proxy auth through a backend, not ship credentials in the client bundle.
  apiUsername: 'admin@all.com',
  apiPassword: 'adminall@321'
};
